<template>
  <div>
    <div>
      <h1 class="mb-5">Welcome!!!</h1>
      <!-- <h1 class="mb-5">
        Instantly verify
        <br />
        your Bayelsa State {{heading}}.
      </h1> -->
      <p class="heading-2">
        Bayelsa State Validation Portal.
      </p>
      <span
        >Simply enter your
        {{ type }}
        Number below</span
      >
      <!-- <span>
        Protect yourself from fraud
        by verifying the authenticity of your
        Bayelsa State {{heading}}.
        Simply enter your {{type=="Receipt" ? 'Receipt' : 'TCC'}} Number below and our system will validate the {{type}}.
      </span> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
    },
    type: {
      type: String,
    },
  },
};
</script>
<style>
.heading-2 {
  color: #383838;
  font-weight: 600;
  font-size: larger;
  margin-bottom: 10px;
}
</style>
